// extracted by mini-css-extract-plugin
export var divider = "_m6-0";
export var labelWrapper = "_m6-2";
export var lineSvg = "_m6-1";